module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/HowToBackground-2439982e5a4c1e61a61852ef16094ca1.jpg";